import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as JActions from "../../../store/modules/journals";
import {PropTypes} from "prop-types";
import Popup from "../Popup";

import {BASE_PATH, JOURNAL_FACET_NAME} from "../../../wpconfig"
import {getSelectFormat, objectToQueryString, pushUrl} from "../../../utils/functions"
import * as func from "../../../utils/functions";

class EditInput extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="form-group"><label><strong>{this.props.title}</strong></label>
				<div>
					<input type="text" name={this.props.name} className="form-control"
					       defaultValue={this.props.value} onKeyUp={this.props.onKeyUp}/>
				</div>
			</div>
		)
	}
};

export default EditInput;